module.exports = __webpack_public_path__ + "media/svg/icon-btn-8b78135b.svg";